export default {
    "name": "ReverseGeocode",
    "kind": "HoudiniQuery",
    "hash": "0716c0c0b622e58cccb23e0db3b4e976264eb5706e5777f72a2c72ac296f0c93",

    "raw": `query ReverseGeocode($position: CoordinatesInput!) {
  reverseGeocode(input: {position: $position}) {
    __typename
    ... on ReverseGeocodeSuccessResult {
      type
      splittedAddress {
        firstLine
        secondLine
      }
      address {
        city
        formattedAddress
        zipCode
        country {
          code
          name
        }
      }
      mapLocation {
        location {
          lat
          lng
        }
      }
    }
    ... on ReverseGeocodeNotFoundResult {
      type
      message
    }
    __typename
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "reverseGeocode": {
                "type": "ReverseGeocodeResult",
                "keyRaw": "reverseGeocode(input: {position: $position})",

                "selection": {
                    "abstractFields": {
                        "fields": {
                            "ReverseGeocodeSuccessResult": {
                                "type": {
                                    "type": "ReverseGeocodeResultType",
                                    "keyRaw": "type",
                                    "visible": true
                                },

                                "splittedAddress": {
                                    "type": "SplittedAddress",
                                    "keyRaw": "splittedAddress",

                                    "selection": {
                                        "fields": {
                                            "firstLine": {
                                                "type": "String",
                                                "keyRaw": "firstLine",
                                                "visible": true
                                            },

                                            "secondLine": {
                                                "type": "String",
                                                "keyRaw": "secondLine",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "address": {
                                    "type": "Address",
                                    "keyRaw": "address",

                                    "selection": {
                                        "fields": {
                                            "city": {
                                                "type": "String",
                                                "keyRaw": "city",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "formattedAddress": {
                                                "type": "String",
                                                "keyRaw": "formattedAddress",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "zipCode": {
                                                "type": "String",
                                                "keyRaw": "zipCode",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "country": {
                                                "type": "Country",
                                                "keyRaw": "country",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "code": {
                                                            "type": "String",
                                                            "keyRaw": "code",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "mapLocation": {
                                    "type": "MapLocation",
                                    "keyRaw": "mapLocation",

                                    "selection": {
                                        "fields": {
                                            "location": {
                                                "type": "Coordinates",
                                                "keyRaw": "location",

                                                "selection": {
                                                    "fields": {
                                                        "lat": {
                                                            "type": "Float",
                                                            "keyRaw": "lat",
                                                            "visible": true
                                                        },

                                                        "lng": {
                                                            "type": "Float",
                                                            "keyRaw": "lng",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                }
                            },

                            "ReverseGeocodeNotFoundResult": {
                                "type": {
                                    "type": "ReverseGeocodeResultType",
                                    "keyRaw": "type",
                                    "visible": true
                                },

                                "message": {
                                    "type": "String",
                                    "keyRaw": "message",
                                    "visible": true
                                },

                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                }
                            }
                        },

                        "typeMap": {}
                    },

                    "fields": {
                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        }
                    }
                },

                "abstract": true,
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "position": "CoordinatesInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=0f37a5f8f17f3127c71dc71068ab679685a5bcfd35c3654b4e66189787e8e70e";